import { appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { SearchedUser, SENDER_TYPE } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Typography } from '@mui/material';

import { ChatProfilePicture } from './ChatProfilePicture';

type SelectedUserProps = Readonly<{
  user: SearchedUser;
}>;

export const SelectedUser = ({ user }: SelectedUserProps) => {
  return (
    <Box sx={containerStyle}>
      <ChatProfilePicture sender={SENDER_TYPE.USER} />
      <Box sx={messageContainerStyle}>
        <Typography sx={selectedTextStyle}>{'Selected'}</Typography>
        <Box sx={selectedUserContainerStyle}>
          {user?.profile_image ? (
            <img src={user?.profile_image} alt={user.name} style={profilePictureStyle} />
          ) : (
            <BackrsIcon name="MyAccountLogo" alt={user?.name} style={profilePictureStyle} />
          )}
          <Typography sx={nameStyle}>{user?.name}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
const containerStyle: React.CSSProperties = {
  display: 'flex',
  marginBottom: '8px',
} as const;

const messageContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  marginTop: '6px',
} as const;

const selectedUserContainerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  backgroundColor: appColors.color.taupe2,
  padding: '4px 8px',
  borderRadius: '5px',
} as const;

const profilePictureStyle: React.CSSProperties = {
  width: '20px',
  height: '20px',
  borderRadius: '50%',
} as const;

const nameStyle: React.CSSProperties = {
  fontWeight: '700',
  fontSize: '11pt',
} as const;

const selectedTextStyle: React.CSSProperties = {
  fontSize: '11pt',
} as const;
